module.exports = __webpack_public_path__ + "media/images/new_culture/factor-approach-125447cb257ab472befbea08a201a326.png";